import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
} from '@chakra-ui/react';
import React from 'react';
import type{ ReactNode } from 'react';

import IconSvg from 'ui/shared/IconSvg';

const CustomContentTooltip = ({ children }: {children: ReactNode}) => {
  return (
    <Popover placement="bottom" openDelay={ 300 } isLazy trigger="hover">
      <>
        <PopoverTrigger>
          <IconButton
            colorScheme="none"
            aria-label="hint"
            icon={ <IconSvg name="info" boxSize={ 5 }/> }
            boxSize={ 5 }
            variant="simple"
            display="inline-block"
            flexShrink={ 0 }
          />
        </PopoverTrigger>
        <PopoverContent border="1px solid" borderColor="divider">
          <PopoverBody>
            { children }
          </PopoverBody>
        </PopoverContent>
      </>
    </Popover>
  );
};

export default CustomContentTooltip;
